import { render } from "./personPage.vue?vue&type=template&id=fa7dbb38&scoped=true"
import script from "./personPage.vue?vue&type=script&lang=js"
export * from "./personPage.vue?vue&type=script&lang=js"

import "./personPage.vue?vue&type=style&index=0&id=fa7dbb38&lang=css"
import "./personPage.vue?vue&type=style&index=1&id=fa7dbb38&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa7dbb38"]])

export default __exports__